<template>
  <div>
    <div v-if="reportInfo.protocol_update_info.protocol_info.type.id === 3">
      <p class="fw-bold mt-3 mb-0">
        Paciente: {{ reportInfo.protocol_update_info.protocol_info.patient_info.name }}
      </p>
      <div class="d-flex">
        <div class="pe-3 py-3">
          <i class="bi bi-clock"></i>
          <strong class="px-1">
            {{ new Date(reportInfo.protocol_update_info.event_slot_info.start).toLocaleString() }} (Horário de Brasília)
          </strong>
        </div>
        <div class="p-3 fw-bold border-start">
          <i class="bi bi-camera-video">
            <a class="ps-2" :href="reportInfo.protocol_update_info.event_slot_info.url" target="_blank">Entrar na vídeo
              chamada</a>
          </i>
        </div>
      </div>
    </div>
    <div v-for="field in reportFields" :key="field.id">
      <div v-if="field.visible">
        <div v-if="field.name === 'specialized_prescription'">
          <div v-if="loadingMemed">
            <p class="fw-bold" style="margin-top: 15px; color: #777777;">Prescrição médica VIA MEMED
              (opcional):</p>
            <button type="button" @click="loadMemed()" :disabled="openingMemed"
              style="margin-top: 5px; background-color: #5D63FE; width: 300px;" class="btn btn-primary">
              <span v-if="openingMemed" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                style="margin-right: 30px;"></span>
              <img v-else src="../assets/logo-memed.png" alt="Ícone de nova prescrição" width="30" height="20"
                style="vertical-align: middle; margin-right: 30px;">
              {{ openingMemed ? 'CARREGANDO...' : '+ NOVA PRESCRIÇÃO' }}
            </button>
          </div>
          <div v-else>
            <p class="fw-bold" style="margin-top: 15px; color: #777777;">Carregando prescrição Memed...</p>
          </div>
        </div>

        <template v-if="field.field_type === 'textarea'">

          <div class="form-group mt-4">
            <label class="fw-bold" style="color: #777777" :for="field.name">{{ field.description }}</label>
            <div class="text-black-50" v-if="field.placeholder">
              {{ field.placeholder }}
            </div>
            <textarea class="form-control text-form-pep" v-model="field.value" :id="field.name"
              :maxlength="field.length" :rows="field.rows" @input="validateInput(field.name, $event)"></textarea>
          </div>
        </template>
        <template v-else-if="field.field_type === 'select'">
          <div class="form-group col-6 mt-4">
            <div class="fw-bold" style="color: #777777" :for="field.name">
              {{ field.description }}
            </div>
            <select class="form-control" @change="onChangeSelect($event.target.value, field)" v-model="field.value">
              <option disabled value="">Selecione uma opção</option>
              <option v-for="option in field.options" :value="option.value" :key="option.description">
                {{ option.description }}
              </option>
            </select>
          </div>
        </template>

        <template v-else-if="field.field_type === 'select-search'">
          <div class="form-group col-6 mt-4">
            <div class="fw-bold" style="color: #777777" :for="field.name">
              {{ field.description }}
            </div>

            <Select2 class="form-control" v-model="field.value" @select="onChangeSelect2($event.id, field)" :settings="{
              allowClear: true,
              placeholder: {
                id: reportInfo.cid_subcategory ? reportInfo.cid_subcategory.id : null,
                text: reportInfo.cid_subcategory ? reportInfo.cid_subcategory.description : null
              },
              language: {
                errorLoading: function () {
                  return 'Os resultados não puderam ser carregados.';
                },
                inputTooLong: function (args) {
                  var overChars = args.input.length - args.maximum;

                  var message = 'Por favor apague ' + overChars + ' ';

                  if (overChars != 1) {
                    message += 'caracteres';
                  }
                  else {
                    message += 'carácter';
                  }

                  return message;
                },
                inputTooShort: function (args) {
                  var remainingChars = args.minimum - args.input.length;

                  var message = 'Por favor, digite ' + remainingChars + ' ou mais caracteres';

                  return message;
                },
                loadingMore: function () {
                  return 'Carregando mais resultados...';
                },
                maximumSelected: function (args) {
                  var message = 'Você pode selecionar apenas ' + args.maximum + ' ite';

                  if (args.maximum != 1) {
                    message += 'ns';
                  }
                  else {
                    message += 'm';
                  }

                  return message;
                },
                noResults: function () {
                  return 'Nenhum resultado encontrado';
                },
                searching: function () {
                  return 'Buscando…';
                },
                removeAllItems: function () {
                  return 'Remover todos os itens';
                }
              },
              width: '100%',
              'ajax': {
                url: api_url + '/resource/cid_subcategory',
                processResults: function (data) {
                  return {
                    results: data.data
                  };
                },
                data: function (params) {
                  return {
                    search: params.term
                  }
                },
                dataType: 'json',
                delay: 250,
              },
              minimumInputLength: 3
            }" />
          </div>
        </template>

        <template v-else-if="field.field_type === 'radio'">
          <div class="form-group col-6 mt-4">
            <label class="fw-bold" style="color: #777777" :for="field.name">{{ field.description }}</label>
            <br />
            <label v-for="(optionRadio, index) in field.options" :key="index">
              <input type="radio" :value="optionRadio.value" v-model="field.value"
                @change="onChangeRadio($event.target.value, field)" :id="field.name + index" />
              {{ optionRadio.description }}
              &nbsp;&nbsp;&nbsp;&nbsp;
            </label>
          </div>
        </template>
        <template v-else-if="field.field_type === 'document_appendix'">
          <div class="form-group mt-4">
            <label class="fw-bold" style="color: #777777" :for="field.name">{{ field.description }}</label>
            <div class="text-black-50" v-if="field.placeholder">
              {{ field.placeholder }}
            </div>
            <br />
            <div class="d-flex">
              <div class="flex-column pe-1" v-for="(document, index) in field.options" :key="index">
                <div class="btn btn-primary"
                  @click="addAppendix({ name: document.value, value: '', description: document.description })">
                  <i class="bi bi-plus-circle px-1"></i>{{ document.description }}
                </div>
              </div>
            </div>
            <div v-for="(appendix, index) in field.value" :key="index">
              <div class="form-group mt-4">
                <label class="fw-bold" style="color: #777777">
                  <i class="bi bi-dash-circle pe-2" @click="removeAppendix(field, index)"></i>{{
                    appendix.description
                  }}: </label>
                <textarea class="form-control text-form-pep" v-model="appendix.value" :rows="4" required></textarea>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

let memedOpenedByUser = false;
let memedGuardInstalled = false;
let memedWatchTimer = null;
const MEMED_WATCH_MS = 30000;
function memedModuleName(payload) {
  if (typeof payload === 'string') return payload;
  return payload?.moduleName ?? payload?.name ?? null;
}

function hideMemedPrescriptionModule() {
  try {
    window.MdHub?.module?.hide('plataforma.prescricao');
  } catch (err) {
    console.error('[MEMED-DEBUG] falha ao esconder o módulo de prescrição:', err);
  }
}

function prescriptionModuleIsShowing() {
  return !!window.MdHub?.module?.listShowing?.['plataforma.prescricao'];
}

function installMemedVisibilityGuard() {
  if (memedGuardInstalled) return false;
  if (!window.MdHub?.event?.add) return false;
  memedGuardInstalled = true;

  window.MdHub.event.add('core:moduleShow', (payload) => {
    if (memedModuleName(payload) !== 'plataforma.prescricao') return;
    if (memedOpenedByUser) return;
    console.warn('[MEMED-DEBUG] módulo de prescrição aberto sem ação do médico — escondendo');
    setTimeout(hideMemedPrescriptionModule, 0);
  });

  window.MdHub.event.add('core:moduleHide', (payload) => {
    if (memedModuleName(payload) === 'plataforma.prescricao') {
      memedOpenedByUser = false;
    }
  });

  return true;
}

function watchMemedModuleVisibility() {
  clearInterval(memedWatchTimer);
  const inicio = Date.now();

  memedWatchTimer = setInterval(() => {
    installMemedVisibilityGuard();

    if (!memedOpenedByUser && prescriptionModuleIsShowing()) {
      hideMemedPrescriptionModule();
    }

    if (Date.now() - inicio > MEMED_WATCH_MS) {
      clearInterval(memedWatchTimer);
      memedWatchTimer = null;
    }
  }, 250);
}

function stopMemedModuleWatch() {
  clearInterval(memedWatchTimer);
  memedWatchTimer = null;
}

export default {
  props: {
    reportFields: Array,
    reportInfo: Object
  },
  computed: {
    ...mapGetters({
      TokenMemed: "StateTokenMemed"
    }),
    hasPrescriptionField() {
      return (this.reportFields || []).some(field => field.name === 'specialized_prescription');
    },
  },
  beforeUnmount() {
    stopMemedModuleWatch();
    memedOpenedByUser = false;
    hideMemedPrescriptionModule();
  },
  async mounted() {
    this.initializeValues();
    if (!this.hasPrescriptionField) {
      return;
    }

    await this.GetTokenMemed();
    if (this.TokenMemed != null) {
      let scriptUrl = process.env.VUE_APP_API_MEMED;
      let script = document.querySelector(`script[src="${scriptUrl}"]`);
      if (!script) {
        script = document.createElement('script');
        script.src = scriptUrl;
        script.dataset.token = this.TokenMemed;
        document.body.appendChild(script);
        watchMemedModuleVisibility();
        script.onload = () => {
          window.MdSinapsePrescricao.event.add('core:moduleInit', async (module) => {
            if (module.name === 'plataforma.prescricao') {
              this.executeLoadingTrue();
              try {
                await window.MdHub.command.send("plataforma.prescricao", "setFeatureToggle", {
                  historyPrescription: true,
                  optionsPrescription: false,
                  emovePrescription: true,
                  copyMedicalRecords: true,
                  buttonClose: true,
                  guidesOnboarding: false,
                  dropdownSync: false,
                  showProtocol: true,
                  showHelpMenu: false,
                });
                await window.MdHub.command.send('plataforma.prescricao', 'setPaciente', {
                  idExterno: this.reportInfo.protocol_update_info.protocol_info.patient_info.id,
                  nome: this.reportInfo.protocol_update_info.protocol_info.patient_info.name,
                  telefone: this.getPhone(this.reportInfo),
                  cpf: this.reportInfo.protocol_update_info.protocol_info.patient_info.document,
                  data_nascimento: this.reportInfo.protocol_update_info.protocol_info.patient_info.birthdate.substring(0, 10),
                  endereco: "Alameda Vicente Pinzon, 54, 11º andar - Vila Olímpia",
                  cidade: "São Paulo"
                });
                await window.MdHub.event.add('prescricaoImpressa', (prescriptionData) => {
                  this.atribuirValor("specialized_prescription", this.formatarMedicamentos(prescriptionData.prescricao.medicamentos));
                });
              } catch (err) {
                console.error('[MEMED-DEBUG] erro dentro do setup de plataforma.prescricao (botão já liberado mesmo assim):', err);
              }
            }
          });
        };
      } else {
        this.loadingMemed = true;
        watchMemedModuleVisibility();
      }
    }
  },
  data() {
    return {
      loadingMemed: false,
      openingMemed: false,
      api_url: process.env.VUE_APP_API_URL,
      appendices: []
    };
  },
  methods: {
    initializeValues() {
      if (this.reportInfo) {
        this.reportFields.forEach(field => {
          if (this.reportInfo.cid_subcategory && field.field_type === "select-search" && !field.value) {
            field.value = this.reportInfo.cid_subcategory.id;
            this.onChangeSelect2(field.value, field)
          } else if (field.field_type === "text") {
            field.rules.forEach((rule) => {
              const targetField = this.reportFields.find(
                (item) => item.name === rule.parameters[2]
              );
              if (targetField && rule.parameters[0] === "field_equals") {
                if (rule.name === "reveals_to") {
                  if (field.value != null) {
                    targetField.visible = rule.parameters[1] === field.value.toString();
                    targetField.value = null;
                  }
                } else if (rule.name === "forces_to") {
                  if (field.value != null) {
                    targetField.required = rule.parameters[1] === field.value.toString();
                    targetField.value = null;
                  }
                }
              }
            });
          }
        });
      }
    },
    ...mapActions(["GetTokenMemed"]),
    ...mapActions(["GetDataConditional"]),
    formatarMedicamentos(array) {
      return array.map(medicamento => {
        const { nome, descricao, posologia, quantidade } = medicamento;
        let resultString = '';
        if (nome) {
          resultString += `Descrição: ${nome},\n`;
        }
        if (descricao) {
          resultString += `${descricao} \n`;
        }
        if (posologia) {
          const posologiaSemTags = posologia.replace(/<\/?p>/g, '');
          resultString += `Posologia: ${posologiaSemTags} \n`;
        }
        if (quantidade) {
          resultString += `Quantidade: ${quantidade}\n`;
        }
        return resultString + '\n\n';
      }).join('');
    },
    atribuirValor(nomeCampo, novoValor) {
      const reportFieldsCopy = this.reportFields.map(field => {
        if (field.name === nomeCampo) {
          return { ...field, value: novoValor };
        }
        return field;
      });
      this.$emit('reportFields', reportFieldsCopy);
    },
    executeLoadingTrue() {
      this.loadingMemed = true;
    },
    getPhone(reportInfo) {
      const responsiblePhones = reportInfo?.protocol_update_info?.responsible_info?.phones;
      const nursePhones = reportInfo?.protocol_update_info?.nurse?.phones;
      if (responsiblePhones?.length > 0) {
        return responsiblePhones[0];
      } else if (nursePhones?.length > 0) {
        return nursePhones[0];
      } else {
        return "";
      }
    },
    async loadMemed() {
      if (this.loadingMemed && !this.openingMemed) {
        this.openingMemed = true;
        try {
          await window.MdHub.command.send('plataforma.prescricao', 'setPaciente', {
            idExterno: this.reportInfo.protocol_update_info.protocol_info.patient_info.id,
            nome: this.reportInfo.protocol_update_info.protocol_info.patient_info.name,
            //telefone: this.getPhone(this.reportInfo),
            cpf: this.reportInfo.protocol_update_info.protocol_info.patient_info.document,
            data_nascimento: this.reportInfo.protocol_update_info.protocol_info.patient_info.birthdate.substring(0, 10),
            endereco: "Alameda Vicente Pinzon, 54, 11º andar - Vila Olímpia, 04547-130",
            cidade: "São Paulo"
          });
          await window.MdHub.event.add('prescricaoImpressa', (prescriptionData) => {
            this.atribuirValor("specialized_prescription", this.formatarMedicamentos(prescriptionData.prescricao.medicamentos));
          });
          memedOpenedByUser = true;
          window.MdHub.module.show('plataforma.prescricao');
        } finally {
          this.openingMemed = false;
        }
      }
    },
    validateInput(fieldName, event) {
      const regex =
        /[^a-zA-Z0-9,.!?áàâãéèêíïóôõöúçÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇ\s()\-:+%#&_/\\|{}[\]#@;'$="]/gu;
      const correctedValue = event.target.value.replace(regex, "");
      event.target.value = correctedValue;
      this[fieldName] = correctedValue;
    },
    onChangeRadio(event, field) {
      field.rules.forEach((rule) => {
        const targetField = this.reportFields.find(
          (item) => item.name === rule.parameters[2]
        );
        if (targetField && rule.parameters[0] === "field_equals") {
          if (rule.name === "reveals_to") {
            targetField.visible = rule.parameters[1] === event;
            targetField.value = "";
          } else if (rule.name === "forces_to") {
            targetField.required = rule.parameters[1] === event;
            targetField.value = "";
          }
        }
      });
    },
    async onChangeSelect(event, field) {
      for (const rule of field.rules) {
        const targetField = this.reportFields.find(
          (item) => item.name === rule.parameters[2]
        );
        if (targetField && rule.parameters[0] === "field_equals") {
          if (rule.name === "reveals_to") {
            targetField.visible = rule.parameters[1] === event;
            targetField.value = null;
          } else if (rule.name === "forces_to") {
            targetField.required = rule.parameters[1] === event;
            targetField.value = null;
          }
        }
      }
    },
    onChangeSelect2: async function (fieldValue, field) {
      const grouped = field.rules.reduce((acc, item) => {
        const key = item.parameters[2];
        if (!acc[key]) {
          acc[key] = [];
          acc[key].visibleIfIn = [];
          acc[key].requiredIfIn = [];
        }
        if (item.name === 'reveals_to') {
          if (item.parameters[0] === "field_equals") {
            acc[key].visibleIfIn.push(item.parameters[1]);
          }
        } else if (item.name === 'forces_to') {
          if (item.parameters[0] === "field_equals") {
            acc[key].requiredIfIn.push(item.parameters[1]);
          }
        }
        return acc;
      }, {});
      for (const [targetFieldName, rule] of Object.entries(grouped)) {
        const targetField = this.reportFields.find(
          (item) => item.name === targetFieldName
        );
        if (targetField) {
          if (rule.visibleIfIn.some((item) => item === fieldValue)) {
            targetField.visible = true;
          } else {
            targetField.visible = false;
            targetField.value = null;
          }
          if (rule.requiredIfIn.some((item) => item === fieldValue)) {
            targetField.required = true;
          } else {
            targetField.required = false;
            targetField.value = null;
          }
        }

      }

    },
    addAppendix(field) {
      const clinicalDocumentsIndex = this.reportFields.findIndex(field => field.name === 'clinical_documents')
      const reportFieldsCopy = this.reportFields;
      if (reportFieldsCopy[clinicalDocumentsIndex].value instanceof Array) {
        reportFieldsCopy[clinicalDocumentsIndex].value.push({
          name: field.name,
          value: field.value,
          description: field.description
        });
      } else {
        reportFieldsCopy[clinicalDocumentsIndex].value = [{
          name: field.name,
          value: field.value,
          description: field.description
        }];
      }
      this.$emit('reportFields', reportFieldsCopy);
    }
    ,
    removeAppendix(field, index) {
      this.$emit('reportFields', this.reportFields.find(item => field.id === item.id).value.splice(index, 1));
    }
  }
  ,
}
  ;
</script>

<style>
.text-form-pep {
  border-radius: 10px;
}
</style>
